import React, { Fragment, useCallback, useEffect, useRef } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import { Link, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";

import {
  clearReferralSourceCreated,
  clearReferralSourceUpdated,
  getListReferralSources,
  clearListReferralSources
} from "../../../store/dashboard/ReferralSources/actions";

import {
  DEFAULT_LIMIT,
  DEFAULT_OFFSET,
} from "../../../constants/pagination";
import Placeholder from "../../../components/Common/Placeholder";
import InfiniteScroll from "../../../components/Common/InfinitScroll";
import useSnackbarState from "../../../hooks/useSnackbarState";
import ReferralSourceTableRow from "./components/ReferralSourceTableRow";
import withUploadingError from "../../../HOCs/withUploadingError";

import styles from "../dashboard.module.scss";
import SEO from "../../../components/Common/SEO";

const ReferralSources = ({
  clearReferralSourceCreated,
  referralSources,
  getListReferralSources,
  clearReferralSourceUpdated,
  // clearBundleRemoved,
  // changeBundleStatusClear,
  clearListReferralSources,
}) => {
  const { data, created, updated, pagination, loading } = referralSources;
  const scrollRef = useRef(null);
  const fetchList = (nextPagination = {}) => {
    const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = nextPagination;
    getListReferralSources({ model: { limit, offset } });
  };

  const [isUpdated] = useSnackbarState(updated, clearReferralSourceUpdated);
  const [isCreated] = useSnackbarState(created, clearReferralSourceCreated);

  const loadMore = useCallback((offset) => fetchList({ offset }), []);

  // useEffect(() => {
  //   // perform effect if entity appears
  //   if (removed) {
  //     fetchList({ limit: DEFAULT_LIMIT, offset: DEFAULT_OFFSET });
  //     clearBundleRemoved();
  //   }
  // }, [removed]);

  useEffect(() => {
    // Fetch data
    fetchList();

    return () => {
      // clearBundleRemoved();
      clearListReferralSources();
    };
  }, []);

  // useEffect(() => {
  //   if (!loading && !!changedStatus) {
  //     changeBundleStatusClear();
  //   }
  // }, [changedStatus, loading]);

  return (
    <>
      <SEO title="Referral Sources" />
      <Row className="page-content h-100">
        <Container fluid className="h-100">
          <Row>
            <Col xs="12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">REFERRAL SOURCES</h4>
              </div>
            </Col>
          </Row>
          {isCreated && (
            <Row>
              <Col xs="12">
                <Alert color="success">
                  New referral source has been successfully created
                </Alert>
              </Col>
            </Row>
          )}
          {isUpdated && (
            <Row>
              <Col xs="12">
                <Alert color="success">
                  The referral source has been successfully updated
                </Alert>
              </Col>
            </Row>
          )}
          <Card className={styles.cardFullsize}>
            <CardBody>
              <CardTitle className="d-flex flex-row justify-content-between pb-3">
                <div className={styles.header}>
                  {/* Category: {item && item.name} */}
                </div>
                <Link to={`/referral-sources/create`}>
                  <Button color="primary">Create Referral Source</Button>
                </Link>
              </CardTitle>
              <CardText tag={"div"}>
                <Row className="h-100 scrollbar-wrapper">
                  {!loading && !data.length && (
                    <Placeholder text="no referral source created" />
                  )}
                  <InfiniteScroll
                    className="w-100 h-100"
                    ref={scrollRef}
                    disabled={data?.length === 0 || loading}
                    offset={pagination.nextOffset}
                    nextOffset={pagination.nextOffset}
                    totalCount={pagination.totalCount}
                    loadMore={loadMore}
                  >
                    {!!data && !!data.length > 0 && (
                      <div className="table-responsive col-12">
                        <Table className="table mt-0 mb-0 border-bottom">
                          <thead className="thead-light">
                            <tr>
                              <th>Referral Source title</th>
                              <th>Referral Source code</th>
                              <th className="w-220px text-right pr-5">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((referralSource, index) => (
                              <Fragment key={"table-item-" + index}>
                                <ReferralSourceTableRow referralSource={referralSource} />
                              </Fragment>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}
                    {loading &&
                      !!data.length &&
                      data.length < pagination.totalCount && (
                        <Col xs={12}>
                          <div className="text-center my-3">
                            <div className="text-success">
                              <i className="bx bx-loader bx-spin font-size-18 align-middle mr-2" />{" "}
                              Load more
                            </div>
                          </div>
                        </Col>
                      )}
                  </InfiniteScroll>
                </Row>
              </CardText>
            </CardBody>
          </Card>
        </Container>
      </Row>
    </>
  );
};

const mapStateToProps = (state) => {
  const { ReferralSources } = state;

  return { referralSources: ReferralSources };
};

export default withUploadingError(
  connect(mapStateToProps, {
    // clearBundleRemoved,

    clearReferralSourceCreated,
    clearReferralSourceUpdated,
    getListReferralSources,
    clearListReferralSources
  })(ReferralSources)
);
